import { render, staticRenderFns } from "./heartDetail.vue?vue&type=template&id=a10078b8&scoped=true"
import script from "./heartDetail.vue?vue&type=script&lang=js"
export * from "./heartDetail.vue?vue&type=script&lang=js"
import style0 from "./heartDetail.vue?vue&type=style&index=0&id=a10078b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10078b8",
  null
  
)

export default component.exports